<div class="short_footer clearfix">

  

  <div class="footer-instruction">
    <p class="copy-rights">{{'footerComp.shortFooter1' | translate }}</p>
    <p class="gambling-text">{{'footerComp.shortFooter2' | translate }}</p>
  </div>
</div>